/**
 * export icin gerekli url i donduren bir fonklsiyon
 * yollanan url i alip
 * /article_offers veya /article_offer_versions ile basliyorsa
 * sonuna /export ekleyerek dondurur
 *
 */

function convertToExportUrl(url) {
  const allowedPrefixes = ['/article_offers', '/article_offer_versions'];

  const prefix = allowedPrefixes.find((p) => p === url.slice(0, p.length));

  const rest = url.slice(prefix.length);
  const [path, query] = rest.split('?');

  return `${prefix}${path}/export${query ? `?${query}` : ''}`;
}

export default convertToExportUrl;
